import React from "react";
import { Button, IconButton, MenuItem, Select, TextField } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

interface ListingFiltersProps {
  type: string;
  onClose: () => void;
}

const renderSelect = (label: string) => (
  <div className="control_group w_100" key={label}>
    <label>{label}</label>
    <Select fullWidth hiddenLabel defaultValue="default">
      <MenuItem value="default">Any</MenuItem>
      <MenuItem value="option1">Option 1</MenuItem>
      <MenuItem value="option2">Option 2</MenuItem>
    </Select>
  </div>
);

const renderInput = (label: string) => (
  <div className="control_group w_100" key={label}>
    <label>{label}</label>
    <TextField fullWidth hiddenLabel placeholder={`Enter ${label}`} />
  </div>
);

function ListingFilters({ type, onClose }: ListingFiltersProps) {
  const getFieldsByType = () => {
    switch (type) {
      case "Car":
        return [
          "Vehicle Type",
          "Brand",
          "Model",
          "Registration Date From",
          "Kilometers To",
          "Price Up To",
          "Location",
        ];

      case "Bike":
      case "Bicycle":
      case "Caravan":
        return [
          "Sub Category",
          "Brand",
          "Model",
          "Registration Date From",
          "Kilometers To",
          "Price Up To",
          "Location",
        ];

      case "Trucks":
        return [
          "Vehicle Type",
          "Brand",
          "Model",
          "Registration Date From",
          "Kilometers To",
          "Price Up To",
          "Location",
        ];

      case "Heavy Equipment":
        return [
          "Equipment Type",
          "Operating Hours",
          "Manufacturing Year",
          "Condition",
          "Fuel Type",
          "Rental Duration",
          "Location",
        ];

      default:
        return [];
    }
  };

  const fields = getFieldsByType();

  return (
    <>
      <div className="drawer_head">
        <h2>{type} Filters</h2>
        <IconButton className="btn_rounded red" onClick={onClose}>
          <ClearIcon />
        </IconButton>
      </div>

      <div className="drawer_body ">
        <div className="table_header">
          <div className="form">
            <div className="gap_p gap_sm">
              {fields.map((field) =>
                field.includes("From") ||
                  field.includes("To") ||
                  field.includes("Hours") ||
                  field.includes("Year")
                  ? renderInput(field)
                  : renderSelect(field)
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="drawer_foot">
        <div className="btn_flex">
          <Button className="btn btn_danger">Clear</Button>
          <Button className="btn btn_primary">Apply</Button>
        </div>
      </div>
    </>
  );
}

export default ListingFilters;
